import React from 'react';

/** A stable home for the active paragraph's controls, outside the screenplay. */
export function ScriptEditingToolbar({targetRef,readOnly=false}: {
    targetRef:(node:HTMLDivElement|null)=>void;readOnly?:boolean;
}) {
    return <div className="sticky top-0 z-40 h-12 border-b border-white/10 bg-zinc-900/95 backdrop-blur px-4">
        <div ref={targetRef} role="toolbar" aria-label="Screenplay formatting" aria-disabled={readOnly}
            className="flex h-full items-center gap-2 overflow-x-auto whitespace-nowrap font-sans text-xs text-zinc-300 empty:before:content-['Select_a_screenplay_paragraph'] empty:before:text-zinc-500 [&_button]:shrink-0 [&_button]:rounded [&_button]:px-2 [&_button]:py-1.5 [&_button:hover]:bg-white/10 [&_button:disabled]:opacity-40 [&_select]:rounded [&_select]:border [&_select]:border-white/10 [&_select]:bg-zinc-900 [&_select]:px-2 [&_select]:py-1" />
    </div>;
}
